import {
  FieldError,
  Label,
  Text as AriaText,
  TextArea as AriaTextArea,
  TextField as AriaTextField,
  type TextFieldProps as AriaTextFieldProps,
} from 'react-aria-components';
import { cn } from '../lib/cn';

export interface TextAreaProps extends Omit<AriaTextFieldProps, 'className'> {
  label: string;
  description?: string;
  errorMessage?: string;
  placeholder?: string;
  rows?: number;
  className?: string;
}

/** Multi-line text with a visible label – same look as TextField. */
export function TextArea({
  label,
  description,
  errorMessage,
  placeholder,
  rows = 5,
  className,
  ...props
}: TextAreaProps) {
  return (
    <AriaTextField {...props} className={cn('flex flex-col gap-gap-xs', className)}>
      <Label className="text-sm font-semibold text-text-secondary">{label}</Label>
      <AriaTextArea
        rows={rows}
        placeholder={placeholder}
        className={cn(
          'w-full rounded-control border border-border-default bg-surface-raised p-inset-sm text-md text-text-primary',
          'placeholder:text-text-muted outline-none',
          'data-focused:border-border-focus data-focus-visible:outline-3 data-focus-visible:outline-border-focus',
          'data-invalid:border-feedback-danger',
        )}
      />
      {description && (
        <AriaText slot="description" className="text-sm text-text-muted">
          {description}
        </AriaText>
      )}
      <FieldError className="text-sm font-semibold text-feedback-danger">{errorMessage}</FieldError>
    </AriaTextField>
  );
}
